import React from 'react';

import { UTMAttribution } from '@common/components/UTMAttribution/UTMAttribution';
import { Cookies } from '@common/components/Cookies/Cookies';
import { I18n } from '@common/components/I18n/I18n';

export const Global = () => (
  <>
    <I18n />
    <UTMAttribution />
    <Cookies />
  </>
);
